import script from "./V4CompletedContentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./V4CompletedContentModal.vue?vue&type=script&setup=true&lang=js"

import "./V4CompletedContentModal.vue?vue&type=style&index=0&id=e6abea90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6abea90"]])

export default __exports__